import { render, staticRenderFns } from "./OpenRolesCard.vue?vue&type=template&id=6aa6bcb4&"
import script from "./OpenRolesCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./OpenRolesCard.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./OpenRolesCard.vue?vue&type=style&index=0&id=6aa6bcb4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports